import React from 'react';
import { CardProps } from '../../types';

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  title,
  padding = 'medium',
  shadow = 'medium'
}) => {
  const paddingStyles = {
    none: 'p-0',
    small: 'p-4',
    medium: 'p-6',
    large: 'p-8'
  };

  const shadowStyles = {
    none: '',
    small: 'shadow-[0_12px_30px_rgba(44,32,27,0.06)]',
    medium: 'shadow-[0_18px_50px_rgba(44,32,27,0.08)]',
    large: 'shadow-[0_24px_70px_rgba(44,32,27,0.12)]'
  };

  return (
    <div className={`rounded-[1.75rem] border border-[color:var(--wf-border)] bg-[linear-gradient(180deg,rgba(251,246,238,0.96),rgba(246,239,229,0.94))] ${shadowStyles[shadow]} ${paddingStyles[padding]} ${className}`}>
      {title && (
        <h2 className="mb-4 font-serif text-3xl text-[color:var(--wf-ink)]">{title}</h2>
      )}
      {children}
    </div>
  );
};

export default Card;
